import { FC, SVGAttributes } from 'react';

type EyeSlashSvgProps = SVGAttributes<SVGElement>;

export const EyeSlashSvg: FC<EyeSlashSvgProps> = ({ ...props }) => {
    return (
        <svg
            width={'24'}
            height={'24'}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <path
                d="M12 17C14.7095 16.9972 17.1317 15.3962 18.7405 12.8821C19.0865 12.3414 19.0865 11.6588 18.7405 11.1181C17.1317 8.60388 14.7095 7.00284 12 7C9.29051 7.00284 6.8683 8.60388 5.25948 11.1181C4.9135 11.6588 4.91351 12.3414 5.25949 12.8821C6.86831 15.3962 9.29052 16.9972 12 17Z"
                stroke={'black'}
                strokeLinecap="round"
            />
            <path
                d="M6 18L10.5858 13.4142M18 6L13.4142 10.5858"
                stroke={'black'}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.4142 10.5858L13.0607 10.9393L13.4142 10.5858ZM10.5858 13.4142L10.9393 13.0607L10.5858 13.4142ZM13.5 12C13.5 12.8284 12.8284 13.5 12 13.5V14.5C13.3807 14.5 14.5 13.3807 14.5 12H13.5ZM10.5 12C10.5 11.1716 11.1716 10.5 12 10.5V9.5C10.6193 9.5 9.5 10.6193 9.5 12H10.5ZM12 10.5C12.4143 10.5 12.7887 10.6673 13.0607 10.9393L13.7678 10.2322C13.3159 9.78038 12.6902 9.5 12 9.5V10.5ZM13.0607 10.9393C13.3327 11.2113 13.5 11.5857 13.5 12H14.5C14.5 11.3098 14.2196 10.6841 13.7678 10.2322L13.0607 10.9393ZM12 13.5C11.5856 13.5 11.2113 13.3327 10.9393 13.0607L10.2322 13.7678C10.6841 14.2196 11.3098 14.5 12 14.5V13.5ZM10.9393 13.0607C10.6673 12.7887 10.5 12.4144 10.5 12H9.5C9.5 12.6902 9.78037 13.3159 10.2322 13.7678L10.9393 13.0607Z"
                fill="black"
            />
        </svg>
    );
};
